import { useContext, useEffect } from "react";
import { AuthContext } from "./AuthRoute";

const LoginCallback = () => {
  const { getTokenSession } = useContext(AuthContext);

  useEffect(() => {
    getTokenSession()
      .then((res) => {
        // if tokens successfully acquired go to MainLanding
        let landingPage = res['id_token']['custom:LandingPage'];
        window.location.href = landingPage
          ? `${window.location.origin}${landingPage}`
          : `${window.location.origin}/MainLanding`;
      })
      .catch((err) => {
        // DO NOTHING -- CHANGE THIS TO REROUTE TO LOGIN ERROR PAGE
      });
  }, []);

  return <></>;
};

export default LoginCallback;
